import store from "@/store/store";
import { get, put } from "@/common/authentication/API";

export function getBuild(character_id: string) {
  const url =
    "https://crescent-backend-v2.herokuapp.com/character/Build" +
    "?character_id=" +
    character_id;
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  return get(url, config);
}
export function putBuild(
  character_id: string,
  build: {
    id: number;
    abilityPointsTotal: number;
    abilityPointsSpent: number;
    archetype: string;
    defenseValuesArmor: number;
    defenseValuesMovement: number;
    defenseValuesShield: number;
    defenseValuesBonus: number;
    hp: number;
    hpMax: number;
    mana: number;
    manaMax: number;
    martialPoints: number;
    movespeed: number;
    movespeedModifier: number;
    originSkill1: string;
    originSkill2: string;
  }
) {
  const url =
    "https://crescent-backend-v2.herokuapp.com/character/Build" +
    "?character_id=" +
    character_id;
  const data = [build];
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  return put(url, data, config);
}
